import { ICellRendererParams } from 'ag-grid-community'
import styled from 'styled-components'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { colorPalette } from '../../../../style/colorPalette'

export const CommentCellRenderer = (
  params: ICellRendererParams<ProgressReportTableContent>
) => {
  return <ScrollableCell>{params.data?.comment}</ScrollableCell>
}

const ScrollableCell = styled('div')({
  fontSize: '14px !important',
  color: colorPalette.monotone[9],
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0,0,0,0.3) transparent',
  '::-webkit-scrollbar': {
    width: 6,
  },
  '::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: 3,
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
})
